class CartDrawer extends HTMLElement {
  constructor() {
    super();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector("#cart-icon-bubble");
    cartLink.setAttribute("role", "button");
    cartLink.setAttribute("aria-haspopup", "dialog");
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button");
    cartDrawerNote.setAttribute("aria-expanded", "false");

    if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
      cartDrawerNote.setAttribute("aria-controls", cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
  }

  renderContents(parsedState) {
    document.getElementById("cart-drawer").classList.contains("is-empty") && document.getElementById("cart-drawer").classList.remove("is-empty");

    this.productId = parsedState.id;

    this.getSectionsToRender().forEach((section) => {
      const elementsWithId = document.querySelectorAll(`#${section.id}`);
      elementsWithId.forEach((element) => {
        const elementToReplace = element.querySelector(section.selector) || element;
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
      });
    });
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, "text/html").querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".cart-icon-bubble",
      },
      {
        id: "main-cart-items",
        section: "main-cart-items",
        selector: ".main-cart-items",
      },
      {
        id: "footer-cart-drawer-section",
        section: "footer-cart-drawer-section",
        selector: ".footer-cart-drawer-section",
      },
      {
        id: "main-cart-footer",
        section: "main-cart-footer",
        selector: ".main-cart-footer",
      },
      {
        id: "main-cart-items-page",
        section: "main-cart-items-page",
        selector: ".main-cart-items-page",
      },
    ];
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser().parseFromString(html, "text/html").querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".cart-icon-bubble",
      },
      {
        id: "main-cart-items",
        section: "main-cart-items",
        selector: ".main-cart-items",
      },
      {
        id: "footer-cart-drawer-section",
        section: "footer-cart-drawer-section",
        selector: ".footer-cart-drawer-section",
      },
      {
        id: "upsell-cart",
        section: "upsell-cart",
        selector: ".upsell-cart",
      },
    ];
  }
}

customElements.define("cart-drawer-items", CartDrawerItems);
